













































































































































































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import TransactionType from "../components/BasicInfo/TransactionType.vue";
import iwBedroomCount from "../components/BasicInfo/BedroomCount.vue";
import iwEpcScore from "../components/BasicInfo/EpcScore.vue";
import iwFloodSensitivityProperty from "../components/BasicInfo/FloodSensitivityProperty.vue";
import iwFloodSensitivityBuilding from "../components/BasicInfo/FloodSensitivityBuilding.vue";
import iwPropertyAddress from "../components/BasicInfo/PropertyAddress.vue";
import { resetBasicInfo, updateClassified, addDefaultValuesToStore, killNotRelevantCriteria, isPropertyInFlanders } from "@/shared/scripts/ValidateData";
import { getFloodInfoRegion, floodInfoLink } from "@/shared/scripts/helpers/regulations/floodInfoLinks.data";
import iwPropertyPrice from "../components/BasicInfo/PropertyPrice.vue";
import iwRequestedMonthlyRentalPrice from "../components/BasicInfo/RequestedMonthlyRentalPrice.vue";
import iwYearlyRentalPrice from "../components/BasicInfo/YearlyRentalPrice.vue";
import iwLandArea from "../components/BasicInfo/LandArea.vue";
import PropertyType from "../components/BasicInfo/PropertyType.vue";
import PropertyCard from "../components/BasicInfo/PropertyCard.vue";
import PriceEstimation from "../components/BasicInfo/PriceEstimation.vue";
import { normalizePropertyType, hasBedroom, hasEpcScore, hasLandArea, hasMonthlyRental} from "../scripts/helpers/property";
import { isAddressFilled } from "../scripts/helpers/address";
import { isPriceValid } from "../scripts/helpers/price";
import { isFormValid, FormValidationParams } from  "../scripts/helpers/formValidation";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import { BasicInfoData, BasicInfoComputed, BasicInfoMethods, BasicInfoProps} from "@/shared/interfaces/optimizedEncoding/BasicInfo.interface";
import { scrollToElementByQuerySelector } from "@/shared/scripts/helpers/function";
import iwNumberOfRooms from "../components/BasicInfo/NumberOfRooms.vue";
import iwIsSubjectToVat from "../components/BasicInfo/isSubjectToVat.vue";
import ClassifiedEditHintTooltip from "../components/ClassifiedEditHintTooltip.vue";
import { getPropertyByAddress } from "@/shared/scripts/propertyByAddress";
import { isFeatureEnabled } from "@/shared/scripts/helpers/featureFlags";

export default Vue.extend<BasicInfoData, BasicInfoMethods, BasicInfoComputed, BasicInfoProps>({
    components: {
        TransactionType: TransactionType,
        iwPropertyAddress: iwPropertyAddress,
        iwBedroomCount: iwBedroomCount,
        iwEpcScore: iwEpcScore,
        iwFloodSensitivityProperty: iwFloodSensitivityProperty,
        iwFloodSensitivityBuilding: iwFloodSensitivityBuilding,
        iwPropertyPrice: iwPropertyPrice,
        iwRequestedMonthlyRentalPrice: iwRequestedMonthlyRentalPrice,
        iwYearlyRentalPrice: iwYearlyRentalPrice,
        PropertyType: PropertyType,
        PropertyCard: PropertyCard,
        PriceEstimation: PriceEstimation,
        iwButtonLoading: iwButtonLoading,
        iwLandArea: iwLandArea,
        iwNumberOfRooms: iwNumberOfRooms,
        iwIsSubjectToVat: iwIsSubjectToVat,
        ClassifiedEditHintTooltip: ClassifiedEditHintTooltip,
    },

    props: {
        isNextSectionVisible: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function(): BasicInfoData {
        return {
            isMobile: true,
            selectedType: "",
            hasUserSelectedPropertyType: false,
            pathInStoreSubtype: "property.subtype",
            pathInStoreTransaction: "transaction.type",
            pathInStoreType: "property.type",
            isLoading: false,
            pathInStorePricePerSqm: "transaction.sale.pricePerSqm",
            submitAttempted: false,
            lastConfirmedPrice: 0,
            firedEvents: {
                propertyType: false,
                basicSpecs: false,
                price: false
            },
            fetchedAddressValues: {} as Record<string, any>,
        };
    },

    computed: {
        ...mapGetters({
            getValueFn: "FormModule/getValue",
        }),
        welcomeGreeting: function(): string {
            const user = this.$store.state.UserModule.user;
            const isLogged = this.$store.getters["UserModule/isLogged"];
            const name = isLogged && user?.username ? ` ${user.username}` : "";
            return this.$t("welcome_funnel.greeting", { name: name }) as string;
        },
        basicInfoFingerprint: function(): string {
            return JSON.stringify({
                street: this.streetInStore,
                number: this.numberInStore,
                floor: this.floorInStore,
                postalCode: this.postalCodeInStore,
                locality: this.localityInStore,
                propertyType: this.propertyType,
                transactionType: this.transactionType,
                bedroomCount: this.bedroomCountInStore,
                numberOfRooms: this.numberOfRoomsInStore,
                epcScore: this.epcScoreInStore,
                landArea: this.landAreaInStore,
                price: this.priceInStore,
                monthlyRental: this.requestedMonthlyPriceInStore,
                isSubjectToVat: this.isSubjectToVatInStore
            });
        },
        bedroomCountInStore: function(): number {
            return Number(this.$store.getters["FormModule/getValue"]("property.bedroom.count") || 0);
        },

        numberOfRoomsInStore: function(): number {
            return Number(this.$store.getters["FormModule/getValue"]("property.livingDescription.roomCount") || 0);
        },

        epcScoreInStore: function(): string  {
            return this.$store.getters["FormModule/getValue"]("transaction.certificates.epc.score") || null;
        },

        landAreaInStore: function(): number {
            return Number(this.$store.getters["FormModule/getValue"]("property.land.surface") || 0);
        },

        priceInStore: function (): number {
            return Number(this.$store.getters["FormModule/getValue"]("transaction.sale.price") || 0);
        },

        isSubjectToVatInStore: function(): boolean {
            return Boolean(this.$store.getters["FormModule/getValue"]("transaction.sale.isSubjectToVat"));
        },

        isKotEnabled: function(): boolean {
            return isFeatureEnabled("kot");
        },

        propertyTypes: function (): Array<{ label: string; value: string; icon: string; }> {
            const tiles: Array<{ label: string; value: string; icon: string; }> = [
                {
                    label: this.$t("house") as string,
                    value: "HOUSE",
                    icon: "images/property/icon-house.svg"
                },
                {
                    label: this.$t("apartment") as string,
                    value: "APARTMENT",
                    icon: "images/property/icon-apartment.svg"
                },
            ];
            if (isFeatureEnabled("kot")) {
                tiles.push({
                    label: this.$t("kot") as string,
                    value: "KOT",
                    icon: "images/property/icon-student-room.svg"
                });
            }
            tiles.push({
                label: this.$t("other") as string,
                value: "OTHER",
                icon: "images/property/icon-other.svg"
            });
            return tiles;
        },

        canShowPriceSection: function(): boolean {
            if (!this.isAddressValid) return false;

            return (
                (!this.hasNumberOfRooms && !this.hasBedroom && !this.hasEpcScore) ||
                ((!this.hasNumberOfRooms || this.isNumberOfRoomsValid) &&
                    (!this.hasBedroom || this.isBedroomCountValid) &&
                    (!this.hasEpcScore || this.isEpcScoreValid)) &&
                this.propertyType !== ""
            );
        },

        isConfirmDisabled: function (): boolean {
            const propertyType = this.getPropertyType();
            const transactionType = this.transactionType;

            // Disable if either is missing
            if (!propertyType || !transactionType ) return true;
            return false;
        },

        hasBedroom: function (): boolean {
            return hasBedroom(this.getPropertyType());
        },

        hasEpcScore: function (): boolean {
            return hasEpcScore(this.getPropertyType());
        },

        hasNumberOfRooms: function (): boolean {
            return ["HOUSE", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1 && this.isCountryFrance;
        },

        hasLandArea: function(): boolean {
            const isForSale =
                this.transactionType === "FOR_SALE";

            if (!isForSale) return false;

            return hasLandArea(this.getPropertyType());
        },

        hasMonthlyRental: function (): boolean {
            return hasMonthlyRental(this.getPropertyType());
        },
        propertyType: function (): string {
            return String(this.$store.getters["FormModule/getValue"](this.pathInStoreType) ?? "");
        },

        transactionType: function (): string {
            return String(this.$store.getters["FormModule/getValue"](this.pathInStoreTransaction) ?? "");
        },

        propertySubtype: function (): string {
            return String(this.$store.getters["FormModule/getValue"](this.pathInStoreSubtype) ?? "");
        },

        isAddressValid: function (): boolean {
            return isAddressFilled(this.getValueFn, this.propertyType);
        },
        isBedroomCountValid: function (): boolean {
            const count = Number(this.$store.getters["FormModule/getValue"]("property.bedroom.count"));
            return count >= 0;
        },
        isEpcScoreValid: function (): boolean {
            return Boolean(this.$store.getters["FormModule/getValue"]("transaction.certificates.epc.score"));
        },
        isNumberOfRoomsValid: function (): boolean {
            const count = Number(this.$store.getters["FormModule/getValue"]("property.livingDescription.roomCount"));
            return count >= 0;
        },
        isFloorValid: function (): boolean {
            const floorValue = this.$store.getters["FormModule/getValue"]("property.location.address.floor");
            return floorValue != null;
        },
        isFloorRequired: function (): boolean {
            // Floor is required for apartments, optional for others
            return this.propertyType === "APARTMENT";
        },

        isPriceValid: function (): boolean {
            return isPriceValid(this.getValueFn);
        },
        isLandAreaValid: function (): boolean {
            const landArea = Number(
                this.$store.getters["FormModule/getValue"]("property.land.surface")
            );

            if (!this.hasLandArea) return true;

            return landArea > 0;
        },
        isSalePriceValid: function (): boolean {
            return isPriceValid(this.getValueFn);
        },
        isCountryFrance: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.location.address.country") === "FR";
        },
        isFlandersAddress: function(): boolean {
            return isPropertyInFlanders(
                this.$store.getters["FormModule/getValue"]("property.location.address.country"),
                this.$store.getters["FormModule/getValue"]("property.location.address.postalCode")
            );
        },
        floodZonesInfo: function(): string {
            const country = this.$store.getters["FormModule/getValue"]("property.location.address.country");
            const postalCode = this.$store.getters["FormModule/getValue"]("property.location.address.postalCode");
            const region = getFloodInfoRegion(country, postalCode);
            const url = floodInfoLink(region);
            const key = region === "flanders"
                ? "everything_about_the_flood_zones_flanders"
                : "everything_about_the_flood_zones";
            return this.$t(key, { "url": url }) as string;
        },
        isFormValidComputed: function (): boolean {
            const params: FormValidationParams = {
                transactionType: this.transactionType,
                propertyType: this.propertyType,
                addressValid: this.isAddressValid,
                hasBedroom: this.hasBedroom,
                bedroomValid: this.isBedroomCountValid,
                hasEpc: this.hasEpcScore,
                epcValid: this.isEpcScoreValid,
                hasNumberOfRooms: this.hasNumberOfRooms,
                numberOfRoomsValid: this.isNumberOfRoomsValid,
                floorValid: this.isFloorValid,
                isFloorRequired: this.isFloorRequired,
                getPrice: () => isPriceValid((path: string) => Number(this.$store.getters["FormModule/getValue"](path))),
            };
            return isFormValid(params) &&
                this.isSalePriceValid &&
                this.isLandAreaValid;
        },
        shouldReloadBasicInfo: function (): boolean {
            return this.$store.getters["FormModule/getValueUI"]("shouldReloadBasicInfo");
        },
        isBusinessRental: function (): boolean {
            return (["OFFICE", "INDUSTRY", "COMMERCIAL"].indexOf(this.getPropertyType()) !== -1 && this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_RENT");
        },
        requestedMonthlyPriceInStore: function (): number {
            return Number(this.$store.getters["FormModule/getValue"]("transaction.rental.monthlyRentalPrice") || 0);
        },
        streetInStore: function(): string {
            return this.$store.getters["FormModule/getValue"]("property.location.address.street");
        },
        numberInStore: function(): string  {
            return this.$store.getters["FormModule/getValue"]("property.location.address.number");
        },
        floorInStore: function(): string {
            return this.$store.getters["FormModule/getValue"]("property.location.address.floor");
        },
        adressBoxInStore:  function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.box");
        },
        postalCodeInStore: function(): string | null {
            return this.$store.getters["FormModule/getValue"]("property.location.address.postalCode");
        },
        localityInStore: function(): string  {
            return this.$store.getters["FormModule/getValue"]("property.location.address.locality");
        },
        addressFingerprint: function(): string {
            return JSON.stringify({
                street: this.streetInStore,
                number: this.numberInStore,
                box: this.adressBoxInStore,
                postalCode: this.postalCodeInStore,
                locality: this.localityInStore,
            });
        },

    },

    watch: {
        selectedType: function(newVal: string, oldVal: string) {
            if (newVal && !oldVal && !this.firedEvents.propertyType) {
                this.firedEvents.propertyType = true;
                pushPageViewEvent("classified_deposit_v2_step1_propertyType");
            }
        },
        propertyType: function(newVal: string | null, oldVal: string | null) {
            if (!newVal) return;
            const subtype = this.$store.getters["FormModule/getValue"](this.pathInStoreSubtype);
            this.selectedType = subtype === "KOT" ? "KOT" : normalizePropertyType(newVal);

            if (oldVal && newVal !== oldVal && this.isAddressValid) {
                this.clearAddressPopulatedData();
                this.fetchPropertyByAddress();
            }
        },
        basicInfoFingerprint: function(newVal: string, oldVal: string) {
            if (newVal === oldVal) return;

            this.invalidateConfirmedBasicInfo();
        },

        shouldReloadBasicInfo: function(newValue: boolean) {
            if (newValue) {
                this.$emit("section-uncompleted");
                this.$store.commit("FormModule/addValueUI", { "path": "shouldReloadBasicInfo", "value": false });
            }
        },

        isAddressValid: function(newVal: boolean) {
            if (newVal && (this.hasNumberOfRooms || this.hasBedroom || this.hasEpcScore) && !this.firedEvents.basicSpecs) {
                this.firedEvents.basicSpecs = true;
                pushPageViewEvent("classified_deposit_v2_step3_basicSpecs");
            }
        },
        canShowPriceSection: function(newVal: boolean) {
            if (newVal && !this.firedEvents.price) {
                this.firedEvents.price = true;
                pushPageViewEvent("classified_deposit_v2_step4_price");
            }
        },
        hasBedroom: {
            immediate: true,
            handler: function() {
                this.ensureBedroomInitialized();
            }
        },
        addressFingerprint: function(newVal: string, oldVal: string) {
            if (newVal === oldVal) return;
            if (!this.isAddressValid) return;


            // Clear previous API populated values
            this.clearAddressPopulatedData();

            // Fetch new data
            this.fetchPropertyByAddress();
        },

        isFlandersAddress: function(newVal: boolean) {
            // The P-score / G-score dropdowns are only shown for Flanders. When the
            // address moves out of Flanders, drop any values the user picked so they
            // are not silently persisted on save.
            if (newVal) return;

            ["property.constructionPermit.pScore", "property.constructionPermit.gScore"].forEach((path: string) => {
                if (this.$store.getters["FormModule/getValue"](path) != null) {
                    this.$store.commit("FormModule/deleteValue", path);
                }
            });
        }

    },

    mounted: function() {
        type TransactionTypeComponent = Vue & {
            updateTransactionType?: (val: string) => void;
        };
        this.$nextTick(() => (this.$refs.transactionTypeComponent as TransactionTypeComponent)?.updateTransactionType?.(this.transactionType));
        const initialSubtype = this.$store.getters["FormModule/getValue"](this.pathInStoreSubtype);
        const initialTileId = initialSubtype === "KOT" ? "KOT" : this.propertyType;
        this.handlePropertyCardSelect(initialTileId, true);
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
        pushPageViewEvent("classified_deposit_v2_landing");

        if(this.$store.getters["FormModule/getIsEditionMode"]) {
            this.$store.dispatch("FormModule/setIsEditionMode", false);
        }
    },

    created: function () {
        this.$store.dispatch("FormModule/resetCriteria");
        this.$store.commit("CustomersModule/resetCustomer");
        this.$store.commit("PicturesModule/setPictures", []);
        this.$store.commit("FormModule/addValueUI", { "path": "shouldReloadBasicInfo", "value": false });
    },

    methods: {
        ...mapActions({
            selectPropertyType: "FormModule/setPropertyType",
            //initValidatedStep: "StepsWizard/validate",
        }),

        validateAndContinue: function(): void {
            this.submitAttempted = true;
            this.isLoading = true;
            this.setPricePerSqm();
            this.ensureBedroomInitialized();

            const retryWithoutFetchedAddress = (pathsToRemove: string[]) => {
                pathsToRemove.forEach((path) => {
                    this.$store.commit("FormModule/deleteValue", path);
                    delete this.fetchedAddressValues[path];
                });
                this.validateAndContinue();
            };

            updateClassified((success: boolean) => {
                this.$nextTick(() => {
                    const firstErrorEl = document.querySelector(".input--error") as HTMLElement;

                    const hasValidationError =
                        !success ||
                        !this.isFormValidComputed ||
                        !!firstErrorEl;

                    if (hasValidationError) {
                        if (firstErrorEl) {
                            scrollToElementByQuerySelector(".input--error");
                        }

                        this.isLoading = false;
                        return;
                    }

                    const errors = this.$store.state.FormModule.errors;
                    const excludedWarnings = ["customerId", "property.description"];
                    const blockingWarnings = (errors?.warnings || []).filter(
                        (warning: any) => !excludedWarnings.includes(warning.property)
                    );

                    // Find fetched fields that are causing warnings (direct or sibling match)
                    const fetchedPaths = Object.keys(this.fetchedAddressValues);
                    const pathsToRemove: string[] = [];
                    blockingWarnings.forEach((w: any) => {
                        const warningPath = w.property as string;
                        if (fetchedPaths.includes(warningPath)) {
                            pathsToRemove.push(warningPath);
                        } else {
                            // Find fetched siblings under same parent
                            const parent = warningPath.substring(0, warningPath.lastIndexOf("."));
                            fetchedPaths.forEach((fp: string) => {
                                if (fp.startsWith(parent + ".") && !pathsToRemove.includes(fp)) {
                                    pathsToRemove.push(fp);
                                }
                            });
                        }
                    });

                    if (this.isFormValidComputed && pathsToRemove.length > 0) {
                        retryWithoutFetchedAddress(pathsToRemove);
                        return;
                    }

                    this.lastConfirmedPrice = Number(this.$store.getters["FormModule/getValue"]("transaction.sale.price"));


                    const id = this.$store.getters["FormModule/getClassifiedId"];
                    const urlTranslated = this.$t("route-optimized-encoding") as string;

                    this.$router.push(`${urlTranslated}/${id}`);
                    this.$emit("section-completed");

                    this.isLoading = false;
                });
            });
        },


        fetchPropertyByAddress: async function(): Promise<void> {
            try {
                this.isLoading = true;

                const addressObj = JSON.parse(this.addressFingerprint);

                const streetPart = [
                    addressObj.street ?? "",
                    addressObj.number ?? "",
                    addressObj.box ?? ""
                ]
                    .filter(Boolean)
                    .join(" ")
                    .trim();
                const postalLocalityPart = [
                    addressObj.postalCode ?? "",
                    addressObj.locality ?? ""
                ]
                    .filter(Boolean)
                    .join(" ")
                    .trim();
                // Combine parts with comma in between
                const addressComplete = [streetPart, postalLocalityPart]
                    .filter(Boolean)
                    .join(", ");
                const response = await getPropertyByAddress(addressComplete, this.propertyType);

                this.populateStoreFromApi(response);

            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },

        flattenObject: function(obj: any, parentKey = "", result: Record<string, any> = {}) {
            Object.keys(obj || {}).forEach((key) => {
                const newKey = parentKey ? `${parentKey}.${key}` : key;
                const value = obj[key];

                if (value && typeof value === "object" && !Array.isArray(value)) {
                    this.flattenObject(value, newKey, result);
                } else {
                    result[newKey] = value;
                }
            });

            return result;
        },

        populateStoreFromApi: function(data: any) {
            const flattened = this.flattenObject(data);
            this.fetchedAddressValues = {};

            Object.entries(flattened).forEach(([path, value]) => {
                if (value === undefined || value === null) return;

                this.$store.dispatch("FormModule/addValue", { path: path, value: value });

                // Save what API set
                this.fetchedAddressValues[path] = value;
            });
        },

        clearAddressPopulatedData: function(): void {
            if (!this.fetchedAddressValues) return;

            Object.entries(this.fetchedAddressValues).forEach(([path, apiValue]) => {
                const currentValue = this.$store.getters["FormModule/getValue"](path);

                // Only delete if value was NOT modified by user
                if (currentValue === apiValue) {
                    this.$store.commit("FormModule/deleteValue", path);
                }
            });

            this.fetchedAddressValues = {};
        },

        invalidateConfirmedBasicInfo: function(): void {
            resetBasicInfo();
            addDefaultValuesToStore(
                this.propertyType,
                this.propertySubtype,
                this.transactionType,
                ""
            );
        },

        ensureBedroomInitialized: function(): void {
            if (!this.hasBedroom) return;

            const bedroom = this.$store.getters["FormModule/getValue"]("property.bedroom");

            if (!bedroom || bedroom.count === undefined) {
                this.$store.dispatch("FormModule/addValue", {
                    path: "property.bedroom",
                    value: {
                        count: 0,
                        hasDressingRoom: false,
                        items: []
                    }
                });

                this.$store.dispatch("FormModule/addValue", {
                    path: "property.bedroom.count",
                    value: 0
                });
            }
        },

        handlePropertyCardSelect: function(tileId: string, skipScroll?: boolean) {
            const isKot = tileId === "KOT";
            const propertyType = isKot ? "APARTMENT" : tileId;
            const propertySubtype = isKot ? "KOT" : tileId;

            this.selectedType = tileId;
            this.selectPropertyType(propertyType);
            this.$store.dispatch("FormModule/addValue", { path: this.pathInStoreSubtype, value: propertySubtype });
            this.$store.commit("FormModule/deleteValue", "property.location.address.floor");

            if (!skipScroll) {
                this.$nextTick(() => {
                    scrollToElementByQuerySelector("input[id*=\"autocomplete-input\"]");
                });
            }

            const transactionType = this.transactionType || "";
            const transactionSubtype = "";
            killNotRelevantCriteria(propertyType, propertySubtype, transactionType, transactionSubtype);
            addDefaultValuesToStore(propertyType, propertySubtype, transactionType, transactionSubtype);
            resetBasicInfo();
        },

        setPricePerSqm: function(): void {
            if (!this.hasLandArea) return;

            const price = Number(
                this.$store.getters["FormModule/getValue"]("transaction.sale.price")
            );

            const landArea = Number(
                this.$store.getters["FormModule/getValue"]("property.land.surface")
            );

            if (!price || !landArea || landArea <= 0) {
                this.$store.commit(
                    "FormModule/deleteValue",
                    "transaction.sale.pricePerSqm"
                );
                return;
            }

            const pricePerSqm = price / landArea;

            this.$store.dispatch("FormModule/addValue", {
                path: "transaction.sale.pricePerSqm",
                value: Math.round(pricePerSqm)
            });
        }

    },
});

